module.exports = __webpack_public_path__ + "media/index/iconography_tall_112x112_spaced-fff86612.png";